import { AutoComplete } from 'primereact/autocomplete';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { OrderList } from 'primereact/orderlist';
import { Sidebar } from 'primereact/sidebar';
import { useEffect, useState } from 'react';
import slugify from 'react-slugify';
import _ from 'underscore';
import FormInput from '../../../../components/Form/FormInput';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useLanguageContext } from '../../../../contexts/LanguageContext';
import { privateFetch } from '../../../../utils/apiHelper';
import { CONSTANT } from '../../../../utils/constants';

function DistributionListManager({
  isOpen,
  onClose,
  createDistribution,
  deleteDistribution,
  handleOrderChange,
  distributions,
  updateDistribution
}) {
  const [distributionList, setDistributionList] = useState([]);
  const { accountContext } = useAccountContext();
  const [filteredDistribList, setFilteredDistribList] = useState([]);
  const [role, setRole] = useState('');
  const [alias, setAlias] = useState('');
  const [popUpVisbile, setPopUpVisbile] = useState(false);
  const [selectedDistribution, setSelectedDistribution] = useState(undefined);
  const { languageContext, setLanguageContext } = useLanguageContext();

  const fetchDistributionList = async () => {
    await privateFetch(
      'GET',
      'banquetceleste',
      `/cu/${accountContext.id}/distribution/?lang=${languageContext}`
    ).then((res) => {
      setDistributionList(res);
    });
  };

  const handleDeleteDistribution = (e, distribution) => {
    console.log('DELETE 1');

    e.stopPropagation();
    e.preventDefault();
    deleteDistribution(distribution);
  };

  useEffect(() => {
    fetchDistributionList();
  }, [distributions]);

  const searchAlias = (event) => {
    setFilteredDistribList(
      distributionList.filter((distribution) =>
        slugify(distribution.alias).includes(slugify(event.query))
      )
    );
  };

  const searchRole = (event) => {
    setFilteredDistribList(
      distributionList.filter((distribution) =>
        slugify(distribution.role).includes(slugify(event.query))
      )
    );
  };

  const handleAddLanguage = (distribution) => {
    setPopUpVisbile(true);
    setSelectedDistribution(distribution);
  };

  const handleValidate = () => {
    const distribPayload = {
      alias: alias,
      role: role
    };
    setAlias('');
    setRole('');
    createDistribution(distribPayload);
  };

  const formIsValid = () => {
    return role && alias;
  };

  const onValidate = () => {
    const payload = {
      id: selectedDistribution.id,
      alias: selectedDistribution.alias,
      role
    };

    updateDistribution(payload);
    setPopUpVisbile(false);
    setRole('');
  };

  const footerButtons = (
    <div className="manager-footer">
      <Button
        key={'validate'}
        label={'Ajouter la traduction'}
        disabled={!role}
        onClick={onValidate}
        severity="success"
        className="w-full"
      />
    </div>
  );

  const addLanguagePopUp = (
    <Dialog
      header="Nouveau tag"
      visible={popUpVisbile}
      draggable={false}
      footer={footerButtons}
      className="h-auto p-15 w-[400px]"
      onHide={() => setPopUpVisbile(false)}>
      <div className="dialog-content-container">
        <div className="manager-form-wrapper">
          <FormInput label={'Nom & Prénom'}>
            <AutoComplete
              value={selectedDistribution?.alias}
              completeMethod={searchAlias}
              disabled
            />
          </FormInput>
          <FormInput label={'Langue'}>
            <Dropdown
              id="language"
              value={languageContext}
              onChange={(e) => setLanguageContext(e.value)}
              options={CONSTANT.banquetceleste.languages}
              optionLabel="label"
              placeholder="Veuillez sélectionner la source"
            />
          </FormInput>
          <FormInput key="type" label={'Role'}>
            <InputText
              value={role}
              placeholder="Veuillez saisir le nom du tag"
              onChange={(e) => setRole(e.target.value)}
            />
          </FormInput>
        </div>
      </div>
    </Dialog>
  );

  const itemTemplate = (d) => (
    <div className="flex flex-col w-full">
      <p className="text-sm text-gray">{d.role}</p>
      <p className="font-semibold">{d.alias}</p>
    </div>
  );

  return (
    <>
      {addLanguagePopUp}

      <Sidebar
        style={{ width: 600 }}
        visible={isOpen}
        position="right"
        onHide={() => onClose(false)}
        header={
          <h3 className="text-slate-800 text-2xl font-medium">{`Modifier la distribution`}</h3>
        }>
        <div className="sidebar-content-container">
          <div className="form-wrapper">
            <div className="flex flex-col gap-y-3 mb-5">
              <h4 className="text-sm font-semibold text-slate-600">Ajouter une nouvelle entrée</h4>

              <div className="flex flex-row ">
                <div className="flex flex-col gap-3 pr-3 w-11/12">
                  <FormInput label={'Nom & Prénom'} required isValid={alias}>
                    <AutoComplete
                      value={alias}
                      suggestions={_.uniq(
                        filteredDistribList.map((distribution) => distribution.alias)
                      )}
                      completeMethod={searchAlias}
                      onChange={(e) => setAlias(e.value)}
                      dropdown
                      autoHighlight
                      scrollHeight={450}
                      placeholder="Saisir le nom et prénom de l'artiste"
                    />
                  </FormInput>
                  <FormInput label={'Rôle'} required isValid={role} translatable>
                    <AutoComplete
                      value={role}
                      suggestions={_.uniq(
                        filteredDistribList.map((distribution) => distribution.role)
                      )}
                      completeMethod={searchRole}
                      onChange={(e) => setRole(e.value)}
                      dropdown
                      autoHighlight
                      scrollHeight={450}
                      placeholder="Saisir un rôle"
                    />
                  </FormInput>
                </div>
                <div className="flex flex-col justify-end items-end w-1/12">
                  <Button
                    key={'validate'}
                    disabled={!formIsValid()}
                    onClick={handleValidate}
                    severity="success"
                    icon="pi pi-check"
                    rounded
                  />
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-y-3 mb-5">
              <h4 className="font-semibold text-slate-600">Modifier l'ordre</h4>

              {distributions?.length ? (
                <OrderList
                  dataKey="id"
                  value={distributions}
                  header={null}
                  onChange={(e) => handleOrderChange(e.value)}
                  itemTemplate={itemTemplate}
                  className="flex flex-row-reverse"></OrderList>
              ) : (
                <span className="text-gray-500 italic text-sm">
                  Aucune distribution pour le moment
                </span>
              )}
            </div>
          </div>
        </div>
      </Sidebar>
    </>
  );
}

export default DistributionListManager;
